import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { inject, observer } from "mobx-react";

@inject("authStore")
@observer
class SignedOut extends Component {
    componentDidMount() {
        this.props.authStore.logout();
    }

    render() {
        return <Redirect to="/sign-in" />;
    }
}

export default SignedOut;
